
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CourseModuleCreateDto, CourseModuleDto } from '../../Manipulate/CoursesObjects/CourseModuleDto';

@Injectable({
  providedIn: 'root'
})
export class CourseModuleService {
  private apiUrl = environment.apiUrl + '/course-module';

  constructor(private http: HttpClient) { }


  public AddModule(dto:CourseModuleCreateDto) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}`,dto);
  }
  public UpdateOrder(newOrder:number,orderId:string) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/updateOrderByModule/${newOrder}/${orderId}`,'');
  }
  public EditModule(dto: CourseModuleCreateDto, moduleId:string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${moduleId}`, dto);
  }
  public GetModuleById(moduleId:string) : Observable<any>{
    return this.http.get(`${this.apiUrl}/${moduleId}`);
  }
  public ListModuleByCourse(courseId:string) : Observable<any>{
    return this.http.get(`${this.apiUrl}/by-course/${courseId}`);
  }
  public Delete(moduleId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${moduleId}`);
  }


}
